// extracted by mini-css-extract-plugin
module.exports = {"Tags":"Tags_Tags__j0ISI","Tags__list":"Tags_Tags__list__dBWzH","Tags__item":"Tags_Tags__item__TXzZc","Tags__item-link":"Tags_Tags__item-link__nUKZN"};